import { Post } from "./apiHelper";

// eslint-disable-next-line import/prefer-default-export
export const postFedback = async (feedback: string): Promise<void> => {
  await Post("/api/feedback", { feedback });
};
